import { Component, inject, OnInit, signal } from '@angular/core';
import {
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router,
  RouterOutlet,
} from '@angular/router';
import { PageLoaderComponent } from './shared/components/page-loader/page-loader.component';
import { PageTitleService } from './shared/services/page-title/page-title.service';
import { IdleTimeoutService } from './core/auth/services/idle-timeout/idle-timeout.service';
import { BrowserTabTrackingService } from './core/auth/services/browser-tab-tracking/browser-tab-tracking.service';
import { ThemeService } from './shared/services/theme/theme.service';
import { StatusModalComponent } from './shared/components/status-modal/status-modal.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, PageLoaderComponent, StatusModalComponent],
  templateUrl: './app.html',
  styleUrl: './app.css',
})
export class App implements OnInit {
  private _activeNavigations = 0;
  private readonly _router = inject(Router);
  private readonly _pageTitleService = inject(PageTitleService);
  private readonly _idleTimeoutService = inject(IdleTimeoutService);
  private readonly _browserTabTrackingService = inject(BrowserTabTrackingService);
  private readonly _themeService = inject(ThemeService);

  protected readonly showLoader = signal(false);

  public ngOnInit(): void {
    this._pageTitleService.initialize();
    this._onRouteChangeListener();
  }

  private _onRouteChangeListener(): void {
    this._browserTabTrackingService.initialize();
    this._idleTimeoutService.start();
    this._router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this._activeNavigations++;
        this.showLoader.set(true);
      } else if (
        event instanceof NavigationEnd ||
        event instanceof NavigationCancel ||
        event instanceof NavigationError
      ) {
        this._activeNavigations = Math.max(0, this._activeNavigations - 1);
        this._hideLoaderIfIdle();
      }
    });
  }

  private _hideLoaderIfIdle(): void {
    if (this._activeNavigations === 0) {
      this.showLoader.set(false);
    }
  }
}
